import SeoHead from '@/components/SEO/SeoHead';
import MarketPage from '@/components/Market/MarketPage';

const Marketplace = () => {
    return (
        <>
            <SeoHead category="Market" path="/marketplace" />
            <MarketPage />
        </>
    );
};

export default Marketplace;
